/*global navigator*/
const io = require('socket.io-client');
const feathers = require('@feathersjs/client');
const socketio = require('@feathersjs/socketio-client');

import store from "Js/store";

const socket = io({
  transports: ["websocket"]
});

const app = feathers();
app.configure(socketio(socket, {
  timeout: 20000
}));

// AUTHENTICATION
app.configure(
  feathers.authentication({
    header: "Authorization", // the default authorization header for REST
    path: "/authentication", // the server-side authentication service path
    jwtStrategy: "jwt", // the name of the JWT authentication strategy
    entity: "user", // the entity you are authenticating (ie. a users)
    service: "users", // the service to look up the entity
    idField: "id",

    cookie: "feathers-jwt", // the name of the cookie to parse the JWT from when cookies are enabled server side
    storageKey: "feathers-jwt", // the key to store the accessToken in localstorage or AsyncStorage on React Native
    storage: window.localStorage, // Passing a WebStorage-compatible object to enable automatic storage on the client.
    timeout: 20000
  })
);

socket.on("reconnect", () => {
  console.log("socket reconnected");
  store.commit('SET_ISONLINE', true);
  app.reAuthenticate();
});
socket.on("connect", function() {
  console.log("socket connected");
  store.commit('SET_ISONLINE', true);
});
socket.on("connecting", function() {
  console.log("socket connecting");
  store.commit('SET_ISONLINE', false);
});
socket.on("connect_failed", function() {
  console.log("socket connection failed");
  store.commit('SET_ISONLINE', false);
});
socket.on("close", function() {
  console.log("socket connection closed");
  store.commit('SET_ISONLINE', false);
});
socket.on("disconnect", function() {
  console.log("socket disconnected");
  store.commit('SET_ISONLINE', false);
});
socket.on("reconnecting", function() {
  console.log("socket reconnecting");
  store.commit('SET_ISONLINE', false);
});
socket.on("reconnect_failed", function() {
  console.log("socket reconnection failed");
  store.commit('SET_ISONLINE', false);
});
socket.on("error", function() {
  console.log("socket error");
  store.commit('SET_ISONLINE', false);
});


app.service("script").timeout = 20000;
app.service("form").timeout = 20000;
app.service("user").timeout = 20000;
app.service("authentication").timeout = 20000;

app.service("messages")
  .on('created', message => {

    store.dispatch('UPDATE_MODEL', {
      model: message.model,
      ind: message.modelIndex || 0
    });
    store.commit('SET_APP', message.app);

    store.dispatch("ACTIONS_QUEUE", message.actions);
  });

app.service("message/sendmessage")
  .on('created', message => {

    store.dispatch('UPDATE_MODEL', {
      model: message.model,
      ind: message.modelIndex || 0
    });
    store.commit('SET_APP', message.app);

    store.dispatch("ACTIONS_QUEUE", message.actions);
  });


const checkOnlineHook = async context => {
  const checkOnlineStatus = () => {
    return new Promise((resolve, reject) => {
      const interval = setInterval(() => {
        if (store.getters.isOnline() && navigator.onLine) {
          clearInterval(interval);
          resolve();
        } else{
            console.log('@checkOnlineHook: Found offline for ', context.method);
        }
      }, 100);

      setTimeout(() => {
        clearInterval(interval);
        reject(new Error('Timeout: Unable to establish connection. Device is offline.'));
      }, 1200);
    });
  };

  try {
    await checkOnlineStatus();
  }
  catch (error) {
    // This error will be thrown to the FeathersJS error handling mechanism
    throw error;
  }

  return context;
};


// SURFACE SERVICES
export { app, socket };

export const userService = app.service("users");
export const logService = app.service("logs");
export const formService = app.service("forms");
export const siteService = app.service("sites");

app.hooks({
  before: {
    all: [checkOnlineHook]
  }
})


export const scriptService = app.service('script');
export const messageService = app.service("messages");
export const messageAddUserService = app.service("message/adduser");
export const messageRemoveUserService = app.service("message/removeuser");
export const pushNotificationSend = app.service("pushdata/sendnotification");
export const pushDataGetKey = app.service("pushdata/vapidpublickey");
export const pushDataRegister = app.service("pushdata/register");
